import { post, get, singleUpload, multiUpload } from "./axios";
// import { routes } from "@/router";
import { apiRoot, apiJob, apiCrew, manRoot } from "@/config";
export const getTodos = () => get("https://jsonplaceholder.typicode.com/todos");

export const postPosts = () =>
  post("https://jsonplaceholder.typicode.com/posts");

// #region NavMenu.vue
// 获取菜单
// export const getNavMenusList = () => {
//   return new Promise((resolve) => {
//     let menusList = [];
//     function getMenu(route, parent) {
//       if (route.meta && route.meta.isNavMenu) {
//         let id = menusList.length;
//         let current = {
//           name: route.meta.title,
//           state: parent
//             ? parent.state + "/" + route.path
//             : "/app/" + route.path,
//           id: id,
//           pid: parent ? parent.id : -1,
//           children: [],
//         };
//         menusList.push(current);
//         if (route.children.length > 0) {
//           route.children.forEach((item) => {
//             let menu = getMenu(item, current);
//             if (menu) current.children.push(menu);
//           });
//         }
//         return route;
//       }
//       return null;
//     }
//     /** 提取app下的目录作为菜单 */
//     // let appRoutes = routes.find((item) => item.path === "/app").children;
//     // appRoutes.forEach((route) => getMenu(route, null));
//     // resolve(menusList);
//   });
// };
export const login = (data) =>
  post(apiRoot + "/user/login", data, { __normal: true }); // 登录和验证验证码合并
// 单文件上传
export const singleFileUpload = (data) =>
  singleUpload("/file/singleFileUpload", data);
// 多文件上传
export const multiFileUploads = (data) =>
  multiUpload("/file/multiFileUploads", data);
//验证手机号是否已经注册
export const checkPhoneIsRegister = (data) =>
  post(apiRoot + `/user/checkPhoneIsRegister`, data);
//验证用户名是否被注册
export const ckLoginName = (data) =>
  post(apiRoot + `/ism/ckLoginName?loginName=${data.id}`);
//获取手机验证码
export const sendCellPhoneNoCode = (data) =>
  post(apiRoot + `/user/sendCellPhoneNoCode`, data);
//个人注册
export const userRegister = (data) =>
  post(apiRoot + "/user/userRegister", data);
//职位
export const queryJobsList = (data) =>
  post(apiJob + "/cyIndex/jobs/list", data, { __normal: true });
//资讯
export const querySeafarerNewsList = (data) =>
  get("querySeafarerNewsList", data);
export const querySeafarerNewsById = (data) =>
  get("querySeafarerNewsById", data);
//培训
export const selectAlITrainplanNotePublishList = (data) =>
  post(apiCrew + "/trainPlan/selectAllTrainPlanNotePublishList", data);
//申报列表
export const selectRecord = (data) => post(apiJob + "/selectRecord", data);
//保存申报
export const saveOrUpdate2 = (data) => post(apiJob + "/saveOrUpdate/2", data);
export const saveOrUpdate1 = (data) => post(apiJob + "/saveOrUpdate/1", data);
//查看申报
export const watchDetail = (data) => get(apiJob + "/detail", data);
export const deleteList = (data) => get(apiJob + "/delete", data);
// 获取文件地址单个 oss/getTemporaryUrl
export const getOneFile = (data) =>
  get(apiRoot + `/oss/crew/platform/getTemporaryUrl`, data);
//获取多个
export const getAllFile = (data) =>
  get(apiRoot + `/oss/crew/platform/getTemporaryUrlList`, data);
//海事申报列表
export const selectRecordMsa = (data) =>
  post(apiJob + "/selectRecordMsa", data);
//媒体详情
export const selecteMediaInfo = (data) =>
  post(apiJob + "/selecteMediaInfo", data);
//媒体添加
export const saveOrUpdateMedia = (data) =>
  get(apiJob + "/saveOrUpdateMedia", data);
//媒体详情
export const mediadetail = (data) => get(apiJob + "/mediadetail", data);
//上架下架
export const showMedia = (data) => get(apiJob + "/show", data);
//删除
export const deleteMedia = (data) => get(apiJob + "/deleteMedia", data);
//省份
export const getProvinceList = (data) =>
  post(apiJob + "/selectProvinceList", data, { __normal: true });
//市区
export const getCityList = (data) =>
  post(apiJob + "/selectCitesByProvCode", data, { __normal: true });
//区县
export const getAreaList = (data) =>
  post(apiJob + "/selectAreaByCityCode", data, { __normal: true });
//保存企业信息
export const updateBaseInfo = (data) =>
  post(apiJob + "/baseCompany/updateBaseInfo", data, { __normal: true });
//企业信息
export const getBaseInfo = (data) =>
  get(apiJob + "/baseCompany/baseInfo", data);
//添加船员  无需审核
export const saveUserList = (data) =>
  post(apiJob + "/agent/library/saveUser", data);
//添加船员  邀请投递
export const saveInviteList = (data) =>
  post(apiJob + "/agent/invite/saveUser", data);
//学历
export const getDictByType = (data) =>
  post(apiRoot + `/crewInfo/selectEducationList`, data);
//航海经验
export const selectDictSailExperienceList = (data) =>
  get(apiRoot + `/ismCrewDict/selectDictSailExperienceList`, data);
//职位
export const selectDictCertPostList = (data) =>
  get(apiRoot + `/ismCrewDict/selectDictCertPostList`, data);
//推送企业职位
export const getshipPositions = (data) =>
  post(apiJob + `/crewInfo/getShipPositions`, data);

//船舶种类&学历
export const selectRecruitDictInfo = (data) =>
  get(apiJob + `/dict/selectRecruitDictInfo`, data);
//船员列表
export const getCrewInfo = (data) =>
  post(apiJob + `/agent/crew/crewAuditList`, data);
//船员库
export const getCrewInfo2 = (data) =>
  post(apiJob + `/agent/crew/crewList`, data);
//详情

export const getCrewDetail2 = (data) =>
  get(apiJob + `/agent/crew/getCrewDetail`, data);

export const getCrewDetail = (data) =>
  get(apiJob + `/agent/crew/getInviteAndResumeCrewDetail`, data);
//发布职位
export const saveOrPublishJob = (data) =>
  post(apiJob + `/recruitment/saveOrPublishJob`, data, { __normal: true });
//职位所属公司
export const getCompanyNameBykeyword = (data) =>
  get(apiJob + `/recruitment/getCompanyNameBykeyword`, data);
//职务
export const getDutyList = (data) => post(apiJob + `/dict/getDutyList`, data);
//证书等级
export const getSrzCertLevelCode = (data) =>
  get(apiJob + `dict/getSrzCertLevelCode`, data);
//登船地点
export const selectShipLocationPortList = (data) =>
  get(apiJob + `dict/selectShipLocationPortList`, data);
//职位列表
export const selectCompanyJobList = (data) =>
  post(apiJob + `/recruitment/selectCompanyJobList`, data, { __normal: true });
//已投递列表
export const ResumeManagement = (data) =>
  post(apiJob + `/company/ResumeManagement`, data, { __normal: true });
//船员审核
export const crewAudit = (data) => post(apiJob + `/agent/crew/crewAudit`, data);
//船舶总吨
export const getTonDict = (data) => get(apiJob + `dict/getTonDict`, data);
//船龄
export const getShipAgeDict = (data) =>
  get(apiJob + `dict/getShipAgeDict`, data);
//职位查看
export const viewJobInfoByJobId = (data) =>
  get(apiJob + `/recruitment/viewJobInfoByJobId`, data);
//职位下线
export const suspendJob = (data) =>
  post(apiJob + `/recruitment/suspend`, data, { __normal: true });
//证书授权
export const requestAuthorize = (data) =>
  post(apiJob + `/agent/crew/requestAuthorize`, data);
//同意
export const responseAuthorize = (data) =>
  post(apiJob + `/agent/crew/responseAuthorize`, data);
//当前授权状态
export const currentAuthorize = (data) =>
  get(apiJob + `/agent/crew/currentAuthorize`, data);
//推送船员到船企
export const rememendCrew = (data) =>
  post(apiJob + `/agent/crew/recommend`, data);
//投递船员
export const resumeManagement = (data) =>
  post(apiJob + `/company/ResumeManagement`, data, { __normal: true });
//面试信息
export const getInterviewList = (data) =>
  post(apiJob + `/agent/library/getInterviewList`, data);
//根据身份证获取
export const getCrewDetailByIdCardNo = (data) =>
  get(apiJob + `/agent/crew/getCrewDetailByIdCardNo`, data);
//船员附件
export const getCrewServiceFile = (data) =>
  get(apiJob + `/crewService/UserFile/list`, data);
//解除绑定
export const updateAgentUserState = (data) =>
  get(apiJob + `/agent/crew/updateAgentUserState`, data);
//公司解除绑定
export const updateUnBindUserToShipCompy = (data) =>
  get(apiJob + `/agent/crew/updateUnBindUserToShipCompy`, data);
//是否完善信息
export const recommendCheckCyServquali = (data) =>
  get(apiJob + `/agent/crew/recommendCheckCyServquali`, data);
//推荐记录
export const selectAgentCyRecommendList = (data) =>
  post(apiJob + `/agent/crew/selectAgentCyRecommendList`, data);
//推荐船员记录列表-查询退回
export const selectRecommendAuditRecordList = (data) =>
  post(apiJob + `/agent/crew/selectRecommendAuditRecordList`, data);
//重新推荐
export const recommendPushAgain = (data) =>
  get(apiJob + `/agent/crew/recommendPushAgain`, data);
//节能考核
export const getSpecialEnergySavingShipList = (data) =>
  post(apiJob + `/getSpecialEnergySavingShipList`, data);
//优秀奖励
export const getSpecialExcellentCrewSummarizeList = (data) =>
  post(apiJob + `/getSpecialExcellentCrewSummarizeList`, data);
//节能考核 船员详情
export const getSpecialEnergySavingUserList = (data) =>
  post(apiJob + `/getSpecialEnergySavingUserList`, data);
//节能考核 船舶详情
export const getSpecialEnergySavingShipDetail = (data) =>
  get(apiJob + `/getSpecialEnergySavingShipDetail`, data);
//其他奖励 -列表
export const getSpecialSafetyGroupShipList = (data) =>
  post(apiJob + `/getSpecialSafetyGroupShipList`, data);
//优秀船员-详情 列表
export const getSpecialExcellentCrewUserList = (data) =>
  post(apiJob + `/getSpecialExcellentCrewUserList`, data);
//优秀船员 详情信息
export const getSpecialExcellentCrewSummarizeDetail = (data) =>
  get(apiJob + `/getSpecialExcellentCrewSummarizeDetail`, data);
//节能考核 审核
export const specialEnergySavingShipLaborAudit = (data) =>
  post(apiJob + `/specialEnergySavingShipLaborAudit`, data);
//优秀船员 审核/
export const specialExcellentCrewUserLaborAudit = (data) =>
  post(apiJob + `/specialExcellentCrewUserLaborAudit`, data);
//其他奖励 审核
export const specialSafetyGroupShipLaborAudit = (data) =>
  post(apiJob + `/specialSafetyGroupShipLaborAudit`, data);
///其他奖励 船员详细
export const getSpecialSafetyGroupUserList = (data) =>
  post(apiJob + `/getSpecialSafetyGroupUserList`, data);
//劳务费用 列表总
export const getLaborShipSettlementSumList = (data) =>
  post(apiJob + `/getLaborShipSettlementSumList`, data);
//劳务费用 明细
export const getLaborUserSettlementList = (data) =>
  post(apiJob + `/getLaborUserSettlementList`, data);
//船舶明细 劳务费用
export const getLaborShipSettlementDetail = (data) =>
  get(apiJob + `/getLaborShipSettlementDetail`, data);
//劳务费用 制表
export const updateAndApproveLaborShipAndUserSettlement = (data) =>
  post(apiJob + `/updateAndApproveLaborShipAndUserSettlement`, data);
//节能考核 导出
export const exportEnergyExcel = (data) =>
  get(apiJob + `/exportSpecialEnergySavingUserList/exportExcel`, data);
//优秀船员 导出
export const exportExcellentExcel = (data) =>
  get(apiJob + `/exportSpecialExcellentCrewUserList/exportExcel`, data);
//其他奖励 导出
export const exportSafetyExcel = (data) =>
  get(apiJob + `/exportSpecialSafetyGroupUserList/exportExcel`, data);
//劳务薪资- 列表
export const monthShipTotalPage = (data) =>
  post(apiJob + `/outsourcing/settlement/monthShipTotalPage`, data);
//劳务薪资- 详情列表
export const monthShipSettlementDetail = (data) =>
  get(apiJob + `/outsourcing/settlement/monthShipSettlementDetail`, data);
//节能
export const showPrepareBindingList = (data) =>
  post(apiJob + `/outsourcing/settlement/showPrepareBindingList`, data);
//制表
export const updateOrApprove = (data) =>
  post(apiJob + `/outsourcing/settlement/updateOrApprove`, data);
// 操作记录
export const getSpecialRewardRecord = (data) =>
  get(apiJob + `/outsourcing/settlement/getSpecialRewardRecord`, data);
// 其他奖励详情
export const getSpecialSafetyGroupShipDetail = (data) =>
  get(apiJob + `/getSpecialSafetyGroupShipDetail`, data);
//船舶审核
export const salaryAss = (data) =>
  post(apiJob + "/getSpecialOutsourcingAssessmentSummarizeList", data);
//详情
export const salaryAssDetail = (data) =>
  post(apiJob + "/getSpecialOutsourcingAssessmentShipList", data);
//外来人员客餐费总表
export const getSpecialShipGuestMeal = (data) =>
  post(apiJob + "/getSpecialShipGuestMealSummarizeList", data);
//外来人员客餐费总表详情
export const getSpecialShipGuestMealList = (data) =>
  post(apiJob + "/getSpecialShipGuestMealList", data);
//审核外来人员客餐费
export const specialShipGuestMealSummarizeAudit = (data) =>
  post(apiJob + "/specialShipGuestMealSummarizeAudit", data);
//审核节能考核
export const energySavingUpdateOrApprove = (data) =>
  post(apiJob + "/energySavingUpdateOrApprove", data);
//选择船员
export const selectUserInfoList = (data) =>
  post(apiJob + "/selectUserInfoList ", data);
//审核节能考核
export const resetPasswordByIdCardNo = (data) =>
  post(apiRoot + "/user/resetPasswordByIdCardNo", data, { __normal: true });
// 申请
export const powerProcDefList = (data) =>
  get(apiRoot + `/processConfig/powerProcDefList`, data);
// id token
export const getLobarShipMappingUserToken = (data) =>
  get(
    apiRoot + `/ismPersonalProtectiveEquipment/getLobarShipMappingUserToken`,
    data
  );
export const pullOwnerShipSalary = (data) =>
  get(apiRoot + "/outsourcing/settlement/pullOwnerShipSalary", data);

//其他奖励核准
export const safetyGroupUpdateOrApprove = (data) =>
  post(apiJob + `/safetyGroupUpdateOrApprove`, data);
// 拉去证书
export const pullCrewCert = (data) => get(manRoot + `/user/pullCrewCert`, data);
